import { render } from "./Toiler.vue?vue&type=template&id=178c1d53&scoped=true"
import script from "./Toiler.vue?vue&type=script&lang=js"
export * from "./Toiler.vue?vue&type=script&lang=js"

import "./Toiler.vue?vue&type=style&index=0&id=178c1d53&scoped=true&lang=css"

import exportComponent from "D:\\VueLearning\\SheepbaseVueJs\\SheepBaseVueApp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178c1d53"]])

export default __exports__